export default "__VITE_ASSET__28dfc79d__"